import axios from 'axios';
import { handleError } from './api.service';

const ROLE_LEVEL = {
    Admin: 5,
    Tenant: 2,
    Maintenance: 1,
};

export const login = async (username, password) => {
    // Always start with clean JSON headers
    axios.defaults.headers = {
        'Content-Type': 'application/json',
    };

    try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/login/`, {
            username,
            password,
        });

        // ── Persist auth details ───────────────────────────────
        const { user, token } = data;
        localStorage.setItem('token', token);
        localStorage.setItem('role', user.role);
        localStorage.setItem('username', user.username);
        localStorage.setItem('roleLevel', ROLE_LEVEL[user.role]);

        // ── Attach token to all future requests ────────────────
        axios.defaults.headers = {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`,
        };

        return data; // success payload
    } catch (error) {
        handleError(error, 'Login failed. Please check your credentials.');
        return null; // signal failure to caller
    }
};

export const forgotPass = async (email) => {
    axios.defaults.headers = {
        'Content-Type': 'application/json',
    };

    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/forgot-password/`, {email});
        return;
    } catch (error) {
        handleError(error, 'Please check your credentials.');
        return null;
    }
}

export const resetPass = async (uid, token, password) => {
    axios.defaults.headers = {
        'Content-Type': 'application/json',
    };

    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/reset-password/`, {
            uid,
            token,
            password    // must match serializer field
        });
        return;
    } catch (error) {
        handleError(error, 'Please check your credentials.');
        return null;
    }
};

const isLogged = () => {
    if (localStorage.getItem('token')) {
        const userRole = localStorage.getItem('role');
        const response = { auth: true, role: userRole };
        return response;
    }
    return false;
};

const logout = () => {
    localStorage.removeItem('user');
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

const AuthService = {
    login,
    logout,
    getCurrentUser,
    isLogged,
    forgotPass,
    resetPass,
};

export default AuthService;
